import React, { useEffect } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import history from './utils/history';
import LoadingOverlay from './components/layout/LoadingOverlay';
import NavBar from './components/layout/NavBar';
import Landing from './components/layout/Landing';
import Routes from './components/routing/Routes';
import PasswordExpiredWarningModal from './components/auth/PasswordExpiredWarningModal';
import axios from 'axios';

// Redux
import { Provider } from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';
import { localStorageKeys } from './utils/constant';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

axios.defaults.headers.post['Content-Type'] = 'application/json';
const { AUTH_TOKEN: KEY_AUTH_TOKEN } = localStorageKeys;
const storedAuthToken = localStorage.getItem(KEY_AUTH_TOKEN);
if (storedAuthToken) {
  setAuthToken(storedAuthToken);
}

const AppContent = ({ auth: { passwordExpiredWarning } }) => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Router history={history}>
      <div style={{ minHeight: window.innerHeight }}>
        <LoadingOverlay />
        <NavBar />
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route component={Routes} />
        </Switch>
        <PasswordExpiredWarningModal isOpen={passwordExpiredWarning} />
      </div>
    </Router>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

const AppContentConnected = connect(mapStateToProps)(AppContent);

const App = () => (
  <Provider store={store}>
    <AppContentConnected />
  </Provider>
);

export default App;
